import React from 'react';

function getGridUrl() {
  if (typeof window !== 'undefined' && window.__DISCOVERY_PUBLIC_URL__) {
    return `${window.__DISCOVERY_PUBLIC_URL__}grid.png`;
  }
  try {
    return `${(typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) || ''}/grid.png`;
  } catch (_) {
    return '/grid.png';
  }
}

function getLogoUrl() {
  if (typeof window !== 'undefined' && window.__DISCOVERY_PUBLIC_URL__) {
    return `${window.__DISCOVERY_PUBLIC_URL__}IDTA_Logo_Grey_Web_M.png`;
  }
  try {
    return `${(typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) || ''}/IDTA_Logo_Grey_Web_M.png`;
  } catch (_) {
    return '/IDTA_Logo_Grey_Web_M.png';
  }
}

const gridUrl = getGridUrl();
const logoUrl = getLogoUrl();

const Footer = () => {
  return (
    <footer
      className="ds-footer ds-footer--with-grid"
      id="ds-footer"
      style={{ backgroundImage: `url(${gridUrl})` }}
    >
      <div className="ds-footer__inner">
        <div className="ds-footer__row">
          <nav className="ds-footer__links">
            <a href="https://adx-hub.com/imprint">Imprint</a>
            <a href="https://industrialdigitaltwin.org/en/privacy">Privacy Policy</a>
          </nav>
          <img src={logoUrl} alt="IDTA" className="ds-footer__logo" />
        </div>
        <p className="ds-footer__copy">&copy; 2025 Industrial Digital Twin Applications GmbH. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
